// extracted by mini-css-extract-plugin
module.exports = {"w1see7f3":"w1see7f3"};